
import { Component, Vue } from 'vue-property-decorator';

import mainStore from '@/store/main-store/MainStore';

@Component({
    name: 'TopHeader',
})
export default class TopHeader extends Vue {
    private mainStore = mainStore.context(this.$store);

    private counterNumer: number = 0;

    private sumCounter(): void {
        this.counterNumer++;
    }

    private get isShowLeftMenu(): boolean {
        return this.mainStore.state.isShowLeftMenu;
    }

    private toggleLeftMenu(): void {
        this.isShowLeftMenu
            ? this.mainStore.actions.hideLeftMenu()
            : this.mainStore.actions.showLeftMenu();
    }
}
